import { MinLayout, PrimaryLayout } from 'components';
import { lazy, useMemo } from 'react';
import { useFeatureFlags } from 'utils/features';
import { IFeatureRouteSetup, IRouteSetup } from './Routes';

const AdpIntegrationRoute: IFeatureRouteSetup = {
  Component: lazy(
    () => import('containers/settings/integrations/vendors/adp/AdpLandingPageRouting/AdpLandingPageRouting')
  ),
  Layout: MinLayout,
  authenticate: true,
  featureFlags: ['INTEGRATION_ADP'],
  path: '/settings/integrations/adp/*',
};

const AgaveIntegrationsRoute: IFeatureRouteSetup = {
  Component: lazy(() => import('containers/settings/integrations/vendors/agave-integrations/AgaveIntegrationsRoute')),
  Layout: MinLayout,
  authenticate: true,
  featureFlags: ['INTEGRATION_AGAVE_INTEGRATIONS'],
  path: '/settings/integrations/agave-integrations/*',
};

const AgaveSettingsRoute: IFeatureRouteSetup = {
  Component: lazy(() => import('containers/settings/integrations/vendors/agave/AgaveSettings/AgaveSettings')),
  Layout: MinLayout,
  authenticate: true,
  featureFlags: ['AGAVE_INTEGRATIONS'],
  path: '/settings/integrations/agave',
};

const CompanyCamLandingPageRoute: IFeatureRouteSetup = {
  Component: lazy(
    () => import('containers/settings/integrations/vendors/company-cam/CompanyCamLandingPage/CompanyCamLandingPage')
  ),
  Layout: MinLayout,
  authenticate: true,
  featureFlags: ['COMPANY_CAM_INTEGRATION'],
  path: '/settings/integrations/company-cam',
};

const CompanyCamSetupRoute: IFeatureRouteSetup = {
  Component: lazy(() => import('containers/settings/integrations/vendors/company-cam/CompanyCamSetup/CompanyCamSetup')),
  Layout: MinLayout,
  authenticate: true,
  featureFlags: ['COMPANY_CAM_INTEGRATION'],
  path: '/settings/integrations/company-cam/setup',
};

const QuickBooksIntegrationRoute: IFeatureRouteSetup = {
  Component: lazy(() => import('containers/settings/integrations/vendors/quickbooks/QuickBooks')),
  Layout: MinLayout,
  authenticate: true,
  featureFlags: ['REACT_SETTINGS_INTEGRATION_QUICKBOOKS'],
  path: '/settings/integrations/quickbooks/*',
};

const QboDirectIntegrationRoute: IFeatureRouteSetup = {
  Component: lazy(() => import('containers/settings/integrations/vendors/qbo-direct/QboDirectIntegrationsRoutes')),
  Layout: MinLayout,
  authenticate: true,
  featureFlags: ['INTEGRATION_QBO_DIRECT'],
  path: '/settings/integrations/qbo/*',
};

const ProcoreIntegrationRoute: IRouteSetup = {
  Component: lazy(() => import('containers/settings/integrations/vendors/procore/ProcoreRoutes/ProcoreRoutes')),
  Layout: PrimaryLayout,
  authenticate: true,
  path: '/settings/integrations/procore/*',
};

const integrationRouteConfigs: IRouteSetup[] = [
  AdpIntegrationRoute,
  AgaveIntegrationsRoute,
  AgaveSettingsRoute,
  CompanyCamLandingPageRoute,
  CompanyCamSetupRoute,
  ProcoreIntegrationRoute,
  QuickBooksIntegrationRoute,
  QboDirectIntegrationRoute,
];

export function useIntegrationRouteConfigs() {
  const enableIntegrations = useFeatureFlags('REACT_SETTINGS_INTEGRATION');

  return useMemo(() => (enableIntegrations ? integrationRouteConfigs : []), [enableIntegrations]);
}
